import "../../utils/messages";
import { ROLES_NOT_RETRIEVED, USER_MESSAGES } from "../../utils/messages";
import { ClientMessage } from "../../utils/objects";

export function assignUserRequests(api) {
    /*****************************************USERS***************************************************************************************/
    //export const userAPI = {
    api.getUser = async function (idUser) {
        var response = await api.get('/accounts/users/' + idUser, this.buildConfig())
            .catch(e => {
                this.checkError(e, USER_MESSAGES.NOT_RETRIEVED);
                return null;
            });
        if (response != null) {
            response.data.ids_groups = response.data.groups.map(group => { return group.id })
            return response.data;
        } else {
            return null;
        }
    }
    api.getUsers = async function () {
        var response = await api.get('/enterprise/accounts/users', this.buildConfig())
            .then(res => res.data.users)
            .catch(e => {
                this.checkError(e, USER_MESSAGES.LIST_NOT_RETRIEVED);
                return [];
            });

        return response;
    }

    api.resetpwd = async function (username) {
        var user = {
            "username": username,
            "one": true
        }
        var response = await api.post('/accounts/pwd/reset', user, this.buildConfig())
            .then(res => 200<=res.status && res.status<=300)
            .catch(e => {
                this.checkError(e, USER_MESSAGES.NOT_SENT);
                return false;
            });
        return response;
    }

    api.sendNewPassword = async function (resetcode, password) {
        var body = {
            "code": resetcode,
            "password": password
        }
        var response = await api.put('/accounts/pwd/reset', body, this.buildConfig())
            .then(res => res)
            .catch(e => {
                this.checkError(e, USER_MESSAGES.PASSWORD_RESET_FAILED);
                return null;
            });
        return response;
    }
    api.validateToken = async function (resettoken) {

        var response = await api.get('/accounts/pwd/reset?code=' + resettoken, this.buildConfig())
            .then(res => res)
            .catch(e => {
                this.checkError(e);
                return null;

            });
        return response;
    }

    /*
     
    {
        "data": {
            "user": {
                "errors": {
                    "email": [
                        "must be a valid email address"
                    ],
                    "password": [
                        "at least one upper case character"
                    ],
                    "username": [
                        "can't be blank"
                    ]
                }
            }
        }
        "status": 422,
        "statusText": "Unprocessable Entity",
        
    }
    */
    api.createUser = async function (user) {
        var clientMessage = ClientMessage.success(USER_MESSAGES.CREATED);
        var config = this.buildConfig();
        var response = response = await api.post(
            '/accounts/users/',
            JSON.stringify(user),
            config
        ).then(res => {
            if (res.status == 400) {
                clientMessage = ClientMessage.error(USER_MESSAGES.NOT_CREATED);
                return null;
            }
            return res.data;
        }).catch(e => {
            clientMessage = this.checkError(e, USER_MESSAGES.NOT_CREATED);
            return null;
        });
        //if (response==null)
        //    this.createToastFunction(this.translateFunction(USER_MESSAGES.NOT_CREATED)+checkErrorDescriptions(e), "alert");
        //else
        this.emitFunction("sendClientMessage", clientMessage, "usermethods");
        if (response && this.vueEnvironment) this.vueEnvironment.rebuildUserMap();
        return response;
    }

    api.editUser = async function (user) {
        var clientMessage = ClientMessage.success(USER_MESSAGES.MODIFIED);
        var response = await api.put(
            '/enterprise/accounts/users/',
            JSON.stringify(user),
            this.buildConfig()
        ).then(res => {
            if (res.status == 400) {
                clientMessage = ClientMessage.error(USER_MESSAGES.NOT_MODIFIED);

                return null;
            }
            return user;
        }).catch(e => {
            clientMessage = this.checkError(e, USER_MESSAGES.NOT_MODIFIED);
            return null;
        });

        this.emitFunction("sendClientMessage", clientMessage, "usermethods");
        if (response && this.vueEnvironment) this.vueEnvironment.rebuildUserMap();
        return response;
    }

    api.deleteUser = async function (id, username) {
        var clientMessage = ClientMessage.success(USER_MESSAGES.DELETED);
        var response = await api.delete('/accounts/users/' + id, this.buildConfig())
            .then(res => {
                if (res.status == 400) {
                    clientMessage = ClientMessage.error(USER_MESSAGES.NOT_DELETED);
                    return false;
                }
                return true;
            })
            .catch(e => {
                clientMessage = this.checkError(e, USER_MESSAGES.NOT_DELETED, { 0: username });
                return false;
            });
        this.emitFunction("sendClientMessage", clientMessage, "usermethods");
        if (response && this.vueEnvironment) this.vueEnvironment.rebuildUserMap();
        return response;
    }

    api.getRoles = async function () {
        var response = await api.get("/roles/", this.buildConfig())
            .then(res => res.data)
            .catch(e => {
                this.checkError(e, ROLES_NOT_RETRIEVED);
                return null;
            });

        return response;
    }
}
